import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
//import $ from 'jquery';

import '../css/topnavbar.css';

class TopNavBar extends Component {
    /*constructor(props) {
        super(props);
        this.closeNavItem = this.closeNavItem.bind(this);
    }

    closeNavItem() {
        $('.navbar-collapse').collapse('hide');
    }*/

    render() {
        const navbarcssclass = "navbar fixed-top navbar-expand-lg navbar-dark scrolling-navbar " + this.props.navbarcssclass;
        const currentPath = window.location.pathname;
        return (
            <nav className={navbarcssclass} style={{ fontSize: "18px" }}>
                <div className="container">
                    <Link className="navbar-brand acmefont darkshadow" style={{ fontSize: "22px" }} to="/"><strong>Dama<span className="primary-cl primary-shadow">trà</span></strong></Link>
                    <button id="btnnavbartoggler" className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                        aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent" style={{ position: "relative" }}>
                        <ul className="navbar-nav navbar-right">
                            <li className={currentPath === "/" ? "nav-item active" : "nav-item"}>
                                <Link to="/" className="nav-link">Home</Link>
                            </li>
                            <li className={currentPath === "/componenti" ? "nav-item active" : "nav-item"}>
                                <Link to="/componenti" className="nav-link">Componenti</Link>
                            </li>
                            <li className={currentPath === "/concerti" ? "nav-item active" : "nav-item"}>
                                <Link to="/concerti" className="nav-link">Concerti</Link>
                            </li>
                            <li className={currentPath === "/gallery" ? "nav-item active" : "nav-item"}>
                                <Link to="/gallery" className="nav-link">Foto & Video</Link>
                            </li>
                            <li className={currentPath === "/contatti" ? "nav-item active" : "nav-item"}>
                                <Link to="/contatti" className="nav-link">Contatti</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        );
    }
}

TopNavBar.propTypes = {
    navbarcssclass: PropTypes.string
};

export default TopNavBar;


// WEBPACK FOOTER //
// ./src/components/TopNavBar.js